import React, { useContext, useEffect, useRef, useState } from 'react';
import { useField, useFormikContext } from 'formik';

import { formatteValeur, formatLabel, removeFromArray, addInArray } from '../../utils/utils';
import { MessageSaisieTrim, MessageSaisieTrimestres } from '../../types/main';
import styled from "@emotion/styled";
import { SaisieContext } from '../formConteneur';
import { Aide } from '../autres/aide';
import { EtapesSaisieContext } from '../../App';

// Styled components ....
// const StyledSelect = styled.select`
//   color: var(--blue);
// `;

// const StyledErrorMessage = styled.div`
//   font-size: 12px;
//   color: var(--red-600);
//   width: 400px;
//   margin-top: 0.25rem;
//   &:before {
//     content: "❌ ";
//     font-size: 10px;
//   }
//   @media (prefers-color-scheme: dark) {
//     color: var(--red-300);
//   }
// `;

// const StyledLabel = styled.label`
//   margin-top: 1rem;
// `;

interface MyTextInputProps {
  label: string;
  labelAvecRC?: JSX.Element;
  toucheRC?: string[];
  name: string;
  id?: string;
  type?: string;
  placeholder?: string;
  // onChange?: () => void;
  mode?: string;
  disabled?: boolean;
  required?: boolean;
  step: number;
  min?: number;
  max?: number;
  autoFocus?: boolean;
  format?: string;
  periode?: string;
  aide?: string;
  onFocus?: () => void;
  classes?: string[];
  forcedFocus?: boolean;
  moyenne_annee?: boolean;
}

export const MyTextInput: React.FC<MyTextInputProps> = (props) => {
  const { setModeAffichage, modeAffichage } = useContext(SaisieContext);
  // const { setBloqueValid } = useContext(EtapesSaisieContext);
  // const { dimensions } = useContext(ResponsiveContext);
  const [focus, setFocus] = useState(false);
  const { setFieldValue } = useFormikContext();
  const [problemeField, setProblemeField] = useState(false);
  const [classNameInput, setClassNameInput] = useState<string[]>([]);

  const {
    label,
    moyenne_annee,
    step,
    id,
    name,
    type,
    placeholder,
    labelAvecRC, toucheRC,
    format, disabled,
    periode,
    aide, classes, forcedFocus, autoFocus,
  } = props;
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input> and alse replace ErrorMessage entirely.
  // console.log('props.name =', name);

  const [field] = useField(props);
  const ref = useRef<HTMLInputElement>(null);
  const _format = format !== undefined ? format : 'euros';
  const _periode = periode ? periode : '';

  const handleBlur = (): void => {
    alert(props.max + ' ' + field.value);
    
    if ((props.max && field.value > props.max) || (props.min && field.value < props.min)) {
      if (ref.current) {
        alert('limites !');
        ref.current!.focus();
      }
    }
  }

  const handleFocus = (): void => {
    if (!disabled) {
      setModeAffichage(false);
      setFocus(true);
    }
  }

  // if (step === undefined) step = 1;


  // ajout ou suppression du listener pour touche raccourci
  // lors de l'entrée ou de la sortie du mode affichage
  useEffect(() => {
    // ne s'affiche pas
    // console.log('useEffect de MyTextInput');
    
    const handleRC = (event: KeyboardEvent): void => {
      if (toucheRC && toucheRC.includes(event.key) && modeAffichage) {
        event.preventDefault();
        setModeAffichage(false);
        if (ref.current) ref.current!.focus();
      }
    }
    window.addEventListener('keydown', handleRC);

    return (): void => {
      window.removeEventListener('keydown', handleRC);
    };
  }, [modeAffichage, toucheRC, setModeAffichage]);

  // clic ou appui sur Enter
  useEffect(() => {
    // ne s'affiche pas
    // console.log('useEffect de MyTextInput');

    if ((focus || forcedFocus) && !modeAffichage) {
      if (ref.current) {
        ref.current!.focus();
        ref.current!.select();
        setFocus(false);
      }
    }
  }, [modeAffichage, focus, forcedFocus]);

  useEffect(() => {
    const _classNameInput = [...classNameInput];
    if (field.value > 20 || field.value < 0) {
      setProblemeField(true);
      addInArray(_classNameInput, 'invalide');
    } else {
      setProblemeField(false);
      removeFromArray(_classNameInput, 'invalide');
    }
    setClassNameInput(_classNameInput);
  }, [field.value])

  const myprops = { ...props, type: type ? type : "text" };
  delete myprops.labelAvecRC;
  delete myprops.toucheRC;
  delete myprops.classes;
  delete myprops.forcedFocus;
  delete myprops.moyenne_annee;
  // delete myprops.autoFocus;
  // delete myprops.disabled;

  const classNameDivGen = classes ? [...classes] : [];
  classNameDivGen.push('label-div');
  const classNameDivSaisieGen = classes ? [...classes] : [];
  classNameDivSaisieGen.push('label-input');
  const _className = ['div_input'];

  let ret = <></>;
  let baliseLabel = <>{label}</>;
  if (labelAvecRC && !disabled) baliseLabel = <>{labelAvecRC}</>;
  const elementLabel = label === '' ? <></>
    : <label htmlFor={id || name}>{baliseLabel}</label>;
  const elementLabelDiv = label === '' ? <></>
    : <label htmlFor={id || name}>{label}{formatLabel(_format, _periode)}</label>;

  const handleClickDiv = (): void => {
    if (moyenne_annee) alert(MessageSaisieTrim);
  }

  if (modeAffichage) {
    ret = <div className={classNameDivGen.join(' ')}>
      {elementLabel}
      <div className="champ_et_aide">
        <div
          // style={{ width: dimensions.largeurInputs }}
          {...field}
          {...myprops}
          tabIndex={autoFocus ? 4 : -1}
          className={_className.join(' ')}
          onFocus={handleFocus}
          title={disabled ?
            (aide ? aide : '')
            : (toucheRC && toucheRC.length > 0 ?
              `Raccourci clavier : ${toucheRC[0]}` : '')}
        >
          {field.value.toString() === '-1' ?
            '' :
            formatteValeur(_format, _periode, field.value)

          }
        </div>
        {aide && <Aide message={aide} />}
      </div>
      {/* {meta.touched && meta.error ? (
        <div className="error">{meta.error}</div>
      ) : null} */}
    </div>;
  } else {
    ret = <div className={classNameDivSaisieGen.join(' ')}>
    {elementLabelDiv}
    <div className="champ_et_aide" onClick={handleClickDiv}>
      <input
        onFocus={(): void => { if (props.onFocus) {props.onFocus();} handleFocus(); }}
        className={classNameInput.join(' ')}
        ref={ref}
        {...field}
        step={step}
        value={field.value.toString() === '-1' ? '' : field.value}
        {...myprops}
        type={type ? type : "text"}
        placeholder={placeholder ? placeholder : ''}
        title={moyenne_annee ? MessageSaisieTrim : `${MessageSaisieTrimestres}${(step === 1 ? 'au point près.'
          : `à ${step} point${step >= 2 ? 's' : ''} près.`)}`}
        // data-computedCell={computedCell}
      />
        {aide && <Aide message={aide} />}
    </div>
    {/* {meta.touched && meta.error ? (
        <div className="error">{meta.error}</div>
      ) : null} */}
  </div>;
  }

  return ret;
};